/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.group = this.dataset.productGroup || '';
      this.max = 8;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof recentIds !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    itemMatchesGroup(item) {
      if (!this.group) return true;
      const marked = item.getAttribute('data-product-group');
      if (marked) return marked === this.group;
      const skincare = Boolean(item.querySelector('.product-card--skincare'));
      return this.group === 'skincare' ? skincare : !skincare;
    }
    hideRail() {
      this.hidden = true;
      const section = this.closest('.shopify-section');
      if (section) section.hidden = true;
    }
    showRail() {
      this.hidden = false;
      const section = this.closest('.shopify-section');
      if (section) section.hidden = false;
    }
    buildUrl() {
      if (!window.recentlyViewedIds || !window.recentlyViewedIds.length) {
        this.hideRail();
        return;
      }

      window.recentlyViewedIds.forEach((val) => {
        if (val === this.currentId) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
      });

      if (!this.products) {
        this.hideRail();
        return;
      }

      this.url = this.url + encodeURIComponent(this.products);
      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const items = html.querySelectorAll('.ge-rail__item, li.column, .column');
          if (!this.container || !items.length) {
            this.hideRail();
            return;
          }

          this.container.innerHTML = '';
          items.forEach((item) => {
            if (!this.itemMatchesGroup(item)) return;
            if (this.container.children.length >= this.max) return;
            if (!item.classList.contains('ge-rail__item')) {
              item.classList.add('ge-rail__item', 'ge-rail__item--card-lg');
              item.setAttribute('role', 'listitem');
            }
            this.container.appendChild(item);
          });
          if (!this.container.children.length) {
            this.hideRail();
            return;
          }
          this.classList.add('product-recommendations--loaded');
          this.hidden = false;
          this.showRail();

          var rail = this.querySelector('[data-ge-rail]');
          if (rail && window.customElements) {
            rail.dispatchEvent(new CustomEvent('ge:rail-refresh'));
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
